import { render, staticRenderFns } from "./PatientOverviewKnowledge.vue?vue&type=template&id=059b6628&"
import script from "./PatientOverviewKnowledge.vue?vue&type=script&lang=js&"
export * from "./PatientOverviewKnowledge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports